import { useState, useEffect } from "react";
import PhoneInput, { parsePhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "./custom-phone-input.css";

// Pour les drapeaux, vous pouvez utiliser react-phone-number-input/flags ou votre propre composant
import flags from "react-phone-number-input/flags";

export default function PhoneInputWithFlag({ value, onChange }) {
  const [country, setCountry] = useState("CD"); // pays par défaut

  // Détecter le pays via l'IP
  useEffect(() => {
    fetch("https://ipapi.co/json/")
      .then((res) => res.json())
      .then((data) => setCountry(data.country_code))
      .catch(() => {});
  }, []);

  // Mettre à jour le pays selon la saisie du numéro
  useEffect(() => {
    if (!value) return;

    try {
      const phone = parsePhoneNumber(value);
      if (phone?.country && phone.country !== country) {
        setCountry(phone.country);
      }
    } catch {}
  }, [value]);

  return (
    <div style={{ maxWidth: "100%" }}>
      <PhoneInput
        international
        defaultCountry={country}
        countryCallingCodeEditable={true}
        placeholder="Numéro de téléphone"
        value={value}
        onChange={onChange}
        flags={flags}
        className="custom-phone-input"
      />
    </div>
  );
}
